/* PureState offer pop-up (sections/ps-offer-popup.liquid).
   Triggers: delay / scroll % / desktop exit intent (whichever first), each gated by min_seconds since navigation start and
   deferred while the cart drawer (or any Dawn overlay) is open; #anchor, ?ps_offer=open and [data-ps-offer-open] force it.
   Frequency (cookies, path=/, SameSite=Lax, Secure on https): ps_offer_session (session cookie, written on open → once per
   session), ps_offer_done (max-age done_suppress_days, written on capture), ps_offer_closed (only when close_suppress_days
   > 0, written on X / ESC / backdrop close). No time-since-last-visit logic; nothing about the offer is kept in localStorage.
   Card game, step machine, fetch submit of the native customer form (success only when the response URL carries
   customer_posted=true or ps_offer=ok), focus management, editor hooks. The submit is native on purpose: only
   Shopify's hCaptcha bootstrap can attach the captcha token, and it only does so around a real submit event.
   The form never fires a native submit event from its own controls: the submit button click (also what implicit Enter
   submission synthesises) and Enter in the e-mail field are intercepted before the form submission algorithm runs, and a
   form-level guard cancels + stops any stray submit event. Reason: Shopify captcha bootstrap (content_for_header) binds
   every customer form on its first submit event and afterwards re-submits it natively with HTMLFormElement.prototype.submit,
   which navigates to /contact regardless of preventDefault(); the section also opts the form out with data-nocaptcha.
   No copy in JS: every string is pre-rendered as a data-* attribute by the section. */
(function () {
  if (customElements.get('ps-offer-popup')) return;
  var doc = document;
  var dm = !!(window.Shopify && Shopify.designMode);
  var COOKIE_SESSION = 'ps_offer_session';
  var COOKIE_CLOSED = 'ps_offer_closed';
  var COOKIE_DONE = 'ps_offer_done';
  var KEY_PENDING = 'ps_offer_pending';
  /* the chosen problem, carried across the native submit so ps:offer:success still reports it after the redirect */
  var KEY_PROBLEM = 'ps_offer_problem';

  var cookie = {
    get: function (name) {
      try {
        var parts = doc.cookie ? doc.cookie.split('; ') : [];
        for (var i = 0; i < parts.length; i++) {
          var eq = parts[i].indexOf('=');
          if (eq > 0 && parts[i].slice(0, eq) === name) return decodeURIComponent(parts[i].slice(eq + 1));
        }
      } catch (e) {}
      return null;
    },
    /* maxAgeSeconds null/undefined → session cookie */
    set: function (name, value, maxAgeSeconds) {
      var str = name + '=' + encodeURIComponent(value) + '; path=/; SameSite=Lax';
      if (maxAgeSeconds !== null && maxAgeSeconds !== undefined) str += '; max-age=' + Math.max(0, Math.floor(maxAgeSeconds));
      if (location.protocol === 'https:') str += '; Secure';
      try { doc.cookie = str; } catch (e) {}
    },
    del: function (name) { this.set(name, '', 0); }
  };

  var store = {
    local: function (k, v) { try { localStorage.setItem(k, v); } catch (e) {} },
    sget: function (k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } },
    sset: function (k, v) { try { sessionStorage.setItem(k, v); } catch (e) {} },
    sdel: function (k) { try { sessionStorage.removeItem(k); } catch (e) {} }
  };
  var num = function (v, d) { var n = parseInt(v, 10); return isNaN(n) ? d : n; };
  var params = function () { try { return new URLSearchParams(location.search); } catch (e) { return null; } };
  var finePointer = function () { return !!(window.matchMedia && matchMedia('(hover: hover) and (pointer: fine)').matches); };
  /* ms since navigation start (performance.now() counts from timeOrigin ≈ navigationStart) */
  var sinceLoad = function () {
    try {
      if (window.performance && typeof performance.now === 'function') return performance.now();
      if (window.performance && performance.timing && performance.timing.navigationStart) return Date.now() - performance.timing.navigationStart;
    } catch (e) {}
    return Infinity;
  };
  /* Dawn scroll-lock class (cart drawer, menu drawer, search) or the cart drawer itself */
  var overlayOpen = function () {
    return doc.body.classList.contains('overflow-hidden') || !!doc.querySelector('cart-drawer.active');
  };

  customElements.define('ps-offer-popup', class extends HTMLElement {
    connectedCallback() {
      this.d = this.dataset;
      this.dialog = this.querySelector('dialog');
      if (!this.dialog) return;
      this.scroller = this.dialog.querySelector('[data-ps-offer-scroll]') || this.dialog;
      this.inner = this.dialog.querySelector('.ps-offer__inner');
      this.steps = Array.prototype.slice.call(this.dialog.querySelectorAll('.ps-offer__step'));
      this.dots = Array.prototype.slice.call(this.dialog.querySelectorAll('.ps-offer__dot'));
      this.dotList = this.dialog.querySelector('.ps-offer__dots');
      this.progressMark = this.dialog.querySelector('[data-ps-offer-progress-mark]');
      this.cards = Array.prototype.slice.call(this.dialog.querySelectorAll('.ps-offer__card'));
      this.reveal = this.dialog.querySelector('[data-ps-offer-reveal]');
      this.live = this.dialog.querySelector('[data-ps-offer-live]');
      this.form = this.dialog.querySelector('form');
      this.email = this.dialog.querySelector('input[type="email"]');
      this.submit = this.dialog.querySelector('.ps-offer__submit');
      this.error = this.dialog.querySelector('.ps-offer__error');
      this.fallbackTag = this.dialog.querySelector('[data-ps-offer-tag-fallback]');
      this.consent = this.dialog.querySelector('[data-ps-offer-consent]');
      this.radios = Array.prototype.slice.call(this.dialog.querySelectorAll('.ps-problem__radio'));
      this.anchor = this.d.anchor || 'oferta';
      this.flips = 0;
      this.revealed = false;
      this.step = 1;
      this.timers = [];
      this.armed = [];
      this.pending = null;
      this.observer = null;
      this.opener = null;
      this.busy = false;
      /* true only while a submit event we validated is on its way to the captcha bootstrap (see nativeSubmit) */
      this.allowNative = false;
      this.isOpen = false;

      var self = this;
      this.h = {
        click: function (ev) { self.onDocClick(ev); },
        hash: function () { if (location.hash === '#' + self.anchor) self.open('hash'); },
        dialogClick: function (ev) { self.onDialogClick(ev); },
        close: function () { self.onClosed(); },
        cancel: function () { self.timers.push(setTimeout(function () { self.onClosed(); }, 0)); },
        card: function (ev) { self.onCard(ev); },
        radio: function (ev) { self.onRadio(ev); },
        submit: function (ev) { self.onFormSubmit(ev); },
        submitClick: function (ev) { ev.preventDefault(); self.onSubmit(ev); },
        enter: function (ev) { if (ev.key === 'Enter' && !ev.isComposing) { ev.preventDefault(); self.onSubmit(ev); } },
        cont: function () { self.goto(2); },
        input: function () { self.clearError(); },
        scroll: function () { self.onScroll(); },
        exit: function (ev) { if (ev.clientY <= 0) self.request('exit'); },
        select: function (ev) { if (ev.target && ev.target.contains(self)) self.open('editor'); },
        deselect: function (ev) { if (ev.target && ev.target.contains(self)) self.close(); },
        block: function (ev) { if (ev.target && self.contains(ev.target)) { self.open('editor', 2); } }
      };

      this.dialog.addEventListener('click', this.h.dialogClick);
      this.dialog.addEventListener('close', this.h.close);
      this.dialog.addEventListener('cancel', this.h.cancel);
      this.cards.forEach(function (c) { c.addEventListener('click', self.h.card); });
      this.radios.forEach(function (r) { r.addEventListener('change', self.h.radio); });
      if (this.form) this.form.addEventListener('submit', this.h.submit);
      if (this.submit) this.submit.addEventListener('click', this.h.submitClick);
      if (this.email) {
        this.email.addEventListener('input', this.h.input);
        this.email.addEventListener('keydown', this.h.enter);
      }
      var cont = this.dialog.querySelector('[data-ps-offer-continue]');
      if (cont) cont.addEventListener('click', this.h.cont);
      doc.addEventListener('click', this.h.click);
      window.addEventListener('hashchange', this.h.hash);

      if (dm) {
        if (this.d.preview !== 'true') return;
        doc.addEventListener('shopify:section:select', this.h.select);
        doc.addEventListener('shopify:section:deselect', this.h.deselect);
        doc.addEventListener('shopify:block:select', this.h.block);
        this.open('editor');
        return;
      }

      /* Return from the native fallback (hCaptcha / server validation): only when this pop-up started it, or our own marker is present. */
      var p = params();
      var offer = p ? p.get('ps_offer') : null;
      var pending = store.sget(KEY_PENDING) === '1';
      var state = this.d.serverState || '';
      if (offer === 'ok' || (p && p.get('customer_posted') === 'true' && pending)) {
        store.sdel(KEY_PENDING);
        var problem = store.sget(KEY_PROBLEM) || '';
        store.sdel(KEY_PROBLEM);
        this.markDone();
        this.open('return', 'done');
        this.dispatch('ps:offer:success', { problem: problem });
        return;
      }
      if (state === 'error' && pending) {
        store.sdel(KEY_PENDING);
        this.open('return', 3);
        this.showError(this.error ? this.error.textContent.trim() : '');
        return;
      }
      store.sdel(KEY_PENDING);

      /* ?ps_offer=open and #anchor ignore every suppression */
      if (offer === 'open' || location.hash === '#' + this.anchor) {
        this.open(offer === 'open' ? 'param' : 'hash');
        return;
      }
      /* never after capture; not again in this session; not within close_suppress_days of a close (when enabled) */
      if (cookie.get(COOKIE_DONE) || cookie.get(COOKIE_CLOSED) || cookie.get(COOKIE_SESSION)) return;
      this.arm();
    }

    disconnectedCallback() {
      if (!this.h) return;
      this.disarm();
      this.pending = null;
      this.unwatchOverlay();
      this.timers.forEach(clearTimeout);
      this.timers = [];
      doc.removeEventListener('click', this.h.click);
      window.removeEventListener('hashchange', this.h.hash);
      doc.removeEventListener('shopify:section:select', this.h.select);
      doc.removeEventListener('shopify:section:deselect', this.h.deselect);
      doc.removeEventListener('shopify:block:select', this.h.block);
      if (this.dialog && this.dialog.open) {
        try { this.dialog.close(); } catch (e) { this.dialog.removeAttribute('open'); }
      }
      doc.body.classList.remove('overflow-hidden');
      if (this.fallbackTrap && typeof removeTrapFocus === 'function') removeTrapFocus();
    }

    /* ---- triggers ---- */
    arm() {
      var self = this;
      var delay = num(this.d.delay, 0);
      var scroll = num(this.d.scroll, 0);
      if (delay > 0) {
        var t = setTimeout(function () { self.request('delay'); }, delay * 1000);
        this.timers.push(t);
        this.armed.push(function () { clearTimeout(t); });
      }
      if (scroll > 0) {
        this.scrollPct = scroll;
        window.addEventListener('scroll', this.h.scroll, { passive: true });
        this.armed.push(function () { window.removeEventListener('scroll', self.h.scroll); });
        this.onScroll();
      }
      if (this.d.exitIntent === 'true' && finePointer()) {
        doc.documentElement.addEventListener('mouseleave', this.h.exit);
        this.armed.push(function () { doc.documentElement.removeEventListener('mouseleave', self.h.exit); });
      }
    }

    disarm() {
      this.armed.forEach(function (off) { off(); });
      this.armed = [];
      this.scrollTick = false;
    }

    onScroll() {
      if (this.scrollTick) return;
      this.scrollTick = true;
      var self = this;
      /* timer throttle (not rAF: paused in background tabs) */
      this.timers.push(setTimeout(function () {
        self.scrollTick = false;
        if (!self.armed.length) return;
        var max = doc.documentElement.scrollHeight - window.innerHeight;
        if (max <= 0) return;
        var pct = (window.scrollY || window.pageYOffset || 0) / max * 100;
        if (pct >= self.scrollPct) self.request('scroll');
      }, 120));
    }

    /* A trigger fired: the others are disarmed (first wins) and the request waits at the gate. */
    request(reason) {
      if (this.pending || this.isOpen) return;
      this.disarm();
      this.pending = reason;
      this.gate();
    }

    /* Gate: (a) never before min_seconds since navigation start, (b) never while an overlay (cart drawer) is open. */
    gate() {
      var self = this;
      if (!this.pending || this.isOpen) return;
      var wait = num(this.d.minSeconds, 3) * 1000 - sinceLoad();
      if (wait > 0) {
        this.timers.push(setTimeout(function () { self.gate(); }, wait + 20));
        return;
      }
      if (overlayOpen()) { this.watchOverlay(); return; }
      var reason = this.pending;
      this.pending = null;
      this.open(reason);
    }

    watchOverlay() {
      if (this.observer) return;
      var self = this;
      var check = function () {
        if (!self.pending || self.isOpen) { self.unwatchOverlay(); return; }
        if (overlayOpen()) return;
        self.unwatchOverlay();
        self.gate();
      };
      if (typeof MutationObserver === 'function') {
        var mo = new MutationObserver(check);
        mo.observe(doc.body, { attributes: true, attributeFilter: ['class'] });
        var drawer = doc.querySelector('cart-drawer');
        if (drawer) mo.observe(drawer, { attributes: true, attributeFilter: ['class'] });
        this.observer = mo;
      } else {
        var iv = setInterval(check, 500);
        this.observer = { disconnect: function () { clearInterval(iv); } };
      }
    }

    unwatchOverlay() {
      if (!this.observer) return;
      this.observer.disconnect();
      this.observer = null;
    }

    onDocClick(ev) {
      var el = ev.target && ev.target.closest && ev.target.closest('[data-ps-offer-open]');
      if (!el) return;
      ev.preventDefault();
      this.open('link');
    }

    /* ---- open / close ---- */
    open(reason, step) {
      if (!this.dialog) return;
      if (this.dialog.open) { this.goto(step || this.step || 1); return; }
      this.pending = null;
      this.unwatchOverlay();
      this.disarm();
      this.opener = doc.activeElement;
      this.hidden = false;
      if (typeof this.dialog.showModal === 'function') {
        try { this.dialog.showModal(); } catch (e) { this.dialog.setAttribute('open', ''); }
      } else {
        this.dialog.setAttribute('open', '');
        if (typeof trapFocus === 'function') { this.fallbackTrap = true; trapFocus(this.dialog); }
      }
      this.isOpen = true;
      doc.body.classList.add('overflow-hidden');
      /* once per session: the session cookie is written on every real open (forced opens included) */
      if (reason !== 'editor') cookie.set(COOKIE_SESSION, '1', null);
      this.goto(step || this.step || 1);
      this.dispatch('ps:offer:open', { reason: reason });
    }

    close() {
      if (!this.dialog || !this.dialog.open) return;
      try { this.dialog.close(); } catch (e) { this.dialog.removeAttribute('open'); }
      this.onClosed();
    }

    /* Cleanup runs from close() directly and from the dialog's close/cancel events (ESC); the flag makes it idempotent. */
    onClosed() {
      if (!this.isOpen || (this.dialog && this.dialog.open)) return;
      this.isOpen = false;
      doc.body.classList.remove('overflow-hidden');
      if (this.fallbackTrap && typeof removeTrapFocus === 'function') { removeTrapFocus(); this.fallbackTrap = false; }
      /* X / ESC / backdrop before capture: optional close suppression (0 = off) */
      if (!dm && this.step !== 'done') {
        var days = num(this.d.closeSuppressDays, 0);
        if (days > 0) cookie.set(COOKIE_CLOSED, '1', days * 86400);
      }
      var o = this.opener;
      this.opener = null;
      if (o && o.focus && doc.contains(o) && o !== doc.body) { try { o.focus({ preventScroll: true }); } catch (e) {} }
      this.dispatch('ps:offer:close', { step: this.step });
    }

    /* "Backdrop" on a full-screen surface = anything that is not a step, the dots or the X (the tinted image, the empty
       space around the content column and inside it). */
    onDialogClick(ev) {
      var t = ev.target;
      if (!t || !t.closest) return;
      if (t.closest('[data-ps-offer-close]')) { this.close(); return; }
      if (this.d.closeBackdrop !== 'true') return;
      if (t.closest('.ps-offer__step') || t.closest('.ps-offer__progress')) return;
      this.close();
    }

    /* ---- step machine ---- */
    goto(step) {
      this.step = step;
      var target = null;
      this.steps.forEach(function (s) {
        var on = String(s.dataset.step) === String(step);
        s.hidden = !on;
        if (on) target = s;
      });
      var idx = step === 'done' ? 3 : num(step, 1);
      this.dots.forEach(function (dot) { dot.classList.toggle('is-active', num(dot.dataset.dot, 0) <= idx); });
      /* the step counter reads as a spinner once there is nothing left to count: on the done step it becomes a check */
      if (this.dotList) this.dotList.hidden = step === 'done';
      if (this.progressMark) this.progressMark.hidden = step !== 'done';
      if (!target) return;
      var labelled = target.getAttribute('aria-labelledby');
      if (labelled) this.dialog.setAttribute('aria-labelledby', labelled);
      var focusEl = step === 3 && this.email ? this.email : (labelled ? doc.getElementById(labelled) : null);
      if (focusEl && focusEl.focus) {
        /* setTimeout, not rAF: rAF is paused in hidden tabs and the focus move would be lost */
        this.timers.push(setTimeout(function () { try { focusEl.focus({ preventScroll: true }); } catch (e) {} }, 0));
      }
      if (step === 'done') this.dispatch('ps:offer:done', {});
      else this.dispatch('ps:offer:step', { step: step });
      if (this.scroller && this.scroller.scrollTop) this.scroller.scrollTop = 0;
    }

    /* ---- step 1: cards ---- */
    onCard(ev) {
      var card = ev.currentTarget;
      if (this.revealed || card.disabled || card.classList.contains('is-flipped')) return;
      card.classList.add('is-flipped');
      card.setAttribute('aria-pressed', 'true');
      if (card.dataset.labelMatched) card.setAttribute('aria-label', card.dataset.labelMatched);
      this.flips += 1;
      if (this.flips >= num(this.d.revealAfter, 3)) this.doReveal();
    }

    doReveal() {
      var self = this;
      this.revealed = true;
      var flipRest = this.d.flipRemaining === 'true';
      this.cards.forEach(function (c) {
        if (c.classList.contains('is-flipped')) return;
        c.disabled = true;
        if (flipRest) { c.classList.add('is-miss', 'is-flipped'); }
      });
      if (this.reveal) {
        this.reveal.classList.add('is-visible');
        this.reveal.removeAttribute('aria-hidden');
        if (this.live) this.live.textContent = this.reveal.textContent.replace(/\s+/g, ' ').trim();
      }
      this.dispatch('ps:offer:reveal', { flips: this.flips });
      var cont = this.dialog.querySelector('[data-ps-offer-continue]');
      if (cont) { this.timers.push(setTimeout(function () { try { cont.focus({ preventScroll: true }); } catch (e) {} }, 0)); return; }
      var hold = num(this.d.revealHold, 1800);
      var t = setTimeout(function () { if (self.dialog.open && self.step === 1) self.goto(2); }, hold);
      this.timers.push(t);
    }

    /* ---- step 2: problem ---- */
    onRadio(ev) {
      var r = ev.currentTarget;
      if (!r.checked) return;
      var key = r.dataset.key || '';
      /* hand-off to the reviews section (chip pre-select) */
      if (key) store.local(this.d.storageProblem || 'ps_problem', key);
      this.radios.forEach(function (o) {
        var label = o.nextElementSibling;
        if (label) label.classList.toggle('is-selected', o === r);
      });
      this.dispatch('ps:offer:problem', { problem: key });
      var self = this;
      var wait = num(this.d.selectAdvance, 250);
      var t = setTimeout(function () { if (self.dialog.open && self.step === 2) self.goto(3); }, wait);
      this.timers.push(t);
    }

    checkedProblem() {
      for (var i = 0; i < this.radios.length; i++) if (this.radios[i].checked) return this.radios[i];
      return null;
    }

    /* ---- step 3: submit ---- */
    /* A submit event on the form. The one we fire ourselves in nativeSubmit, after the fields validate, is let through
       untouched so the Shopify captcha bootstrap can intercept it, solve the challenge and re-submit with a token.
       Anything else — another script, an unvalidated programmatic submit — is cancelled and sent through validation. */
    onFormSubmit(ev) {
      if (this.allowNative) return;
      ev.preventDefault();
      ev.stopImmediatePropagation();
      this.onSubmit(ev);
    }

    /* Entry for the button click, Enter in the e-mail field and the guard above; ev is cancelled before any early return. */
    onSubmit(ev) {
      if (ev && ev.preventDefault) ev.preventDefault();
      if (this.busy || !this.form) return;
      this.clearError();
      if (!this.email || !this.email.value.trim() || !this.email.checkValidity()) {
        this.showError(this.error ? this.error.dataset.msgInvalid : '');
        if (this.email) { this.email.setAttribute('aria-invalid', 'true'); this.email.focus(); }
        return;
      }
      if (this.consent && !this.consent.checked) {
        this.showError(this.error ? this.error.dataset.msgConsent : '');
        this.consent.focus();
        return;
      }
      var chosen = this.checkedProblem();
      if (this.fallbackTag) this.fallbackTag.disabled = !!chosen;
      this.setBusy(true);
      /* Not a background fetch. Only Shopify's captcha bootstrap can mint the hCaptcha token, and it only does so
         around a real submit event; a fetch POST to /contact is answered 400 "Missing CAPTCHA token" and the address
         is lost (measured on the CDN preview 2026-09-09). The native submit returns through return_to (?ps_offer=ok),
         where the dialog reopens on the success step. */
      this.nativeSubmit();
      /* The challenge can be dismissed, or never resolve, and then the page just sits there. Release the button and
         show the failure copy rather than leaving it stuck on the sending label. */
      var self = this;
      this.timers.push(setTimeout(function () {
        if (self.busy) { self.allowNative = false; self.onFail(); }
      }, 20000));
    }

    /* Hands the form to Shopify's captcha bootstrap. requestSubmit() fires a cancelable submit event, which is what
       the bootstrap listens for; HTMLFormElement.prototype.submit() fires none and would post without a token. */
    nativeSubmit() {
      var f = this.form;
      if (!f) return;
      store.sset(KEY_PENDING, '1');
      var picked = this.checkedProblem();
      store.sset(KEY_PROBLEM, picked ? picked.dataset.key || '' : '');
      if (this.fallbackTag) this.fallbackTag.disabled = !!picked;
      this.allowNative = true;
      if (typeof f.requestSubmit === 'function') { f.requestSubmit(this.submit || undefined); return; }
      /* No requestSubmit (old browsers): fire the event by hand so the bootstrap can still take over. If nothing
         cancels it, post natively — that attempt carries no token and will fail, but it is the honest last resort. */
      var ev = null;
      try { ev = new Event('submit', { bubbles: true, cancelable: true }); } catch (e) {}
      if (ev && !f.dispatchEvent(ev)) return;
      if (typeof HTMLFormElement !== 'undefined') HTMLFormElement.prototype.submit.call(f);
    }

    onFail() {
      this.setBusy(false);
      this.showError(this.error ? this.error.dataset.msgNetwork : '');
      if (this.submit) this.submit.focus();
    }

    /* captured: never again (done_suppress_days), and a previous close suppression no longer matters */
    markDone() {
      var days = num(this.d.doneSuppressDays, 365);
      cookie.set(COOKIE_DONE, '1', days > 0 ? days * 86400 : null);
      cookie.del(COOKIE_CLOSED);
    }

    setBusy(on) {
      this.busy = on;
      if (!this.submit) return;
      if (on) {
        this.submit.dataset.labelIdle = this.submit.textContent;
        if (this.submit.dataset.labelSending) this.submit.textContent = this.submit.dataset.labelSending;
        this.submit.setAttribute('aria-busy', 'true');
        this.submit.disabled = true;
      } else {
        if (this.submit.dataset.labelIdle) this.submit.textContent = this.submit.dataset.labelIdle;
        this.submit.removeAttribute('aria-busy');
        this.submit.disabled = false;
      }
    }

    showError(msg) {
      if (!this.error) return;
      this.error.textContent = msg || '';
      this.error.hidden = !msg;
    }

    clearError() {
      if (!this.error) return;
      if (!this.error.hidden) { this.error.hidden = true; this.error.textContent = ''; }
      if (this.email) this.email.removeAttribute('aria-invalid');
    }

    dispatch(name, detail) {
      this.dispatchEvent(new CustomEvent(name, { bubbles: true, detail: detail || {} }));
    }
  });
})();
